<template>
  <div id="badmintom_knockoutRounds" v-show="currThemeObj">
    <div class="select_area">
      <marathon_select_opt
        :currThemeObj="currThemeObj"
        :data="selectOptData"
        @changeSelectEvent="changeSelect"
      ></marathon_select_opt>
    </div>
    <div class="match_list" v-show="!isNotDataFlag" ref="cupSche_matchList">
      <div class="publishBtn_row">
        <!-- <span
            class="theme_publishBtn home"
            @click="clickPublicTheme(themeList[0] ? themeList[0] : null)"
          >
            <svg
              t="1692698307306"
              class="publishBtn_icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="9670"
              width="50%"
              height="50%"
            >
              <path
                d="M853.333333 533.333333a32 32 0 0 1 64 0v266.666667c0 64.8-52.533333 117.333333-117.333333 117.333333H224c-64.8 0-117.333333-52.533333-117.333333-117.333333V256c0-64.8 52.533333-117.333333 117.333333-117.333333h277.333333a32 32 0 0 1 0 64H224a53.333333 53.333333 0 0 0-53.333333 53.333333v544a53.333333 53.333333 0 0 0 53.333333 53.333333h576a53.333333 53.333333 0 0 0 53.333333-53.333333V533.333333z m-42.058666-277.333333l-89.792-95.402667a32 32 0 0 1 46.613333-43.861333l140.544 149.333333C927.861333 286.485333 913.376 320 885.333333 320H724.704C643.029333 320 576 391.210667 576 480v192a32 32 0 1 1-64 0V480c0-123.296 94.784-224 212.704-224h86.570667z"
                p-id="9671"
              ></path>
            </svg>
          </span> -->

        <MultipleChoiceSharingMenuRow
          v-if="
            MultipleChoiceSharingMenuRow_list &&
            MultipleChoiceSharingMenuRow_list.length > 0
          "
          :list="MultipleChoiceSharingMenuRow_list"
          :baseOpt="MultipleChoiceSharingMenuRow_baseOpt"
          @clickMenuEvent="MultipleChoiceSharingMenuRow_clickMenuHandler"
          @clickPublicThemeEvent="
            MultipleChoiceSharingMenuRow_clickPublicThemeHandler
          "
        ></MultipleChoiceSharingMenuRow>
      </div>
      <HTML_KNOCKOUT_T4T6T8
        :currThemeObj="currThemeObj"
        :datas="origin_knockoutList"
        :detailPathName="`badmintonScheduleDetail_${currThemeObj.moduleRouteNameEn}`"
      ></HTML_KNOCKOUT_T4T6T8>
    </div>
    <cup_notData className="relativePtb60" v-show="isNotDataFlag"></cup_notData>
  </div>
</template>

<script>
// import matchList_mock from './matchList_mock.json'
import {
  https_season_eventList,
  https_badminton_knockoutData,
} from '@api/platfrom_badminton_api'
import marathon_select_opt from '@components/platfromBase/marathon/select_opt.vue'
import HTML_KNOCKOUT_T4T6T8 from '@components/football/html/HTML_KNOCKOUT/teamsForT4OrT6OrT8.vue'
import cup_notData from '@components/base/NO_DATA.vue'
import cup_base_data_mixin from '@mixins/cup_base_data'
import MultipleChoiceSharingMenuRow from '@components/base/theme/multipleChoiceSharingMenuRow.vue'
import single_findAnalysisItem_data_mixin from '@mixins/single_findAnalysisItem_data'
// import knockout_page from './knockout.vue'
export default {
  name: 'badmintom_knockoutRounds',
  components: {
    marathon_select_opt,
    HTML_KNOCKOUT_T4T6T8,
    cup_notData,
    MultipleChoiceSharingMenuRow,
  },
  mixins: [cup_base_data_mixin, single_findAnalysisItem_data_mixin],
  data() {
    return {
      themeTemplateType: 33,
      findAnalysisItemParams: null,
      isNotDataFlag: false,
      themeList: [],
      origin_knockoutList: { data: { dataList: [] } },
      knockoutList: [],
      currStageEvent: null,
      eventArr: [],
      selectOptData: {
        configArr: [
          {
            type: 'event',
            title: '组别',
            origin_keyVal: ['eventId', 'eventName'], // 源数据list [唯一id, 需要展示文字]
            dataName: 'eventArr', //this下面的存储该数据list字段名
            selectIndex: 0,
            isFilterable: true,
          },
        ],
        selectOpt_list: [],
      },
      MultipleChoiceSharingMenuRow_baseOpt: {
        openMenuWidthVw: '22.2vw', // 打开的总宽度
        closeMenuWidthVw: '6.4vw', // 收起来的总宽度
      },
      MultipleChoiceSharingMenuRow_originBaseOpt: [
        {
          openMenuWidthVw: '13.8vw', // 打开的总宽度
          closeMenuWidthVw: '6.4vw', // 收起来的总宽度
        },
        {
          openMenuWidthVw: '22.2vw', // 打开的总宽度
          closeMenuWidthVw: '6.4vw', // 收起来的总宽度
        },
        {
          openMenuWidthVw: '33.3vw', // 打开的总宽度
          closeMenuWidthVw: '6.4vw', // 收起来的总宽度
        },
      ],
      MultipleChoiceSharingMenuRow_list: [
        // {
        //   id: 'top4',
        //   name: '四强晋级',
        //   isAct: false,
        // },
        // {
        //   id: 'top8',
        //   name: '八强晋级',
        //   isAct: false,
        // },
      ],
    }
  },
  created() {
    if (this.currGroup) {
      this.init()
    }
  },
  methods: {
    async init() {
      // this.origin_matchList = matchList_mock.data
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)

      console.debug(this.currCid, this.currSid)
      await this.getStageEvent()
      console.debug(this.stageArr)
      this.computedSelectOpt(this.selectOptData.configArr)
      await this.getKnockoutData()

      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    makeAnalysisItemParams(themeTemplateType) {
      // 每个页面单独设置不同函数
      this.findAnalysisItemParams = {
        sportType: 'badminton',
        templateType: themeTemplateType,
        cid: this.currCid,
        sid: this.currSid,
        did: 0,
        eid: this.currStageEvent,
        pid: 0,
        mid: 0,
      }
      if (this.initSingleFindAnalysisItem) {
        this.initSingleFindAnalysisItem(this.findAnalysisItemParams)
      }
    },
    MultipleChoiceSharingMenuRow_clickMenuHandler(item) {
      this.MultipleChoiceSharingMenuRow_list.forEach((menuItem, meunIndex) => {
        if (item.id === menuItem.id) {
          menuItem.isAct = true
          this.themeItem = this.themeList[meunIndex]
        } else {
          menuItem.isAct = false
        }
      })
    },
    MultipleChoiceSharingMenuRow_clickPublicThemeHandler(item) {
      let themeItem = this.themeItem
      if (themeItem) {
        this.clickPublicTheme(themeItem)
      } else {
        console.error('没有找到对应分享的主题数据：themeItem')
      }
    },
    findAnalysisItemCallback(resData) {
      if (resData && resData.length > 0) {
        this.themeList = resData.map((item) => {
          item.actJson = JSON.parse(item.json)
          item.renderData = null
          return item
        })
        let MultipleChoiceSharingMenuRow_list = []
        // 重置分享按钮的名字
        this.themeList.forEach((shareItem) => {
          MultipleChoiceSharingMenuRow_list.push({
            id: shareItem.analysisItemId,
            name: shareItem.twoTitle,
            isAct: false,
          })
        })
        let themeList_length = this.themeList.length
        this.MultipleChoiceSharingMenuRow_list =
          MultipleChoiceSharingMenuRow_list
        // 不同的主题个数，分享按钮的长度不一样
        this.MultipleChoiceSharingMenuRow_baseOpt =
          this.MultipleChoiceSharingMenuRow_originBaseOpt[themeList_length - 1]
        // 选中最后一个分享按钮【高亮】
        this.MultipleChoiceSharingMenuRow_clickMenuHandler(
          this.MultipleChoiceSharingMenuRow_list[themeList_length - 1]
        )
      } else {
        this.themeList = []
        this.MultipleChoiceSharingMenuRow_list = null
      }
    },
    computedSelectOpt(configArr) {
      // 组装选择框数据
      let selectOpt_list = []
      configArr.forEach((config, index) => {
        let disabledArr = []
        const mix_id = `mix_${config.origin_keyVal[0]}`
        let list = []
        if (config.isDatePicker) {
          // 日期选择框没有 dataName 属性
          selectOpt_list.push({
            type: config.type,
            title: config.title,
            keyVal: [mix_id, config.origin_keyVal[1]],
            curId: mix_id, //list[config.selectIndex][mix_id], // 选中的id,是改装后的，需要去掉前缀才是源数据的唯一id
            curVal: this.currStageMatchDate ? this.currStageMatchDate : '', // 这个值是源数据需要展示的值，没有做过修改
            disabledArr,
            list,
            isDatePicker: config.isDatePicker,
          })
        } else {
          list = this[config.dataName].map((item) => {
            item[mix_id] = `${config.type}_${item[config.origin_keyVal[0]]}`
            return item
          })
          console.debug(
            'computedSelectOpt 11:',
            config.type,
            config.dataName,
            this[config.dataName],
            list,
            mix_id
          )
          selectOpt_list.push({
            type: config.type,
            title: config.title,
            keyVal: [mix_id, config.origin_keyVal[1]],
            curId: list[config.selectIndex][mix_id], // 选中的id,是改装后的，需要去掉前缀才是源数据的唯一id
            curVal: list[config.selectIndex][config.origin_keyVal[1]], // 这个值是源数据需要展示的值，没有做过修改
            disabledArr, //当【阶段】选择为淘汰赛时，球队这栏置灰；所以在【球队】这组对象的disabledArr=['stage_2']；而【阶段】的disabledArr = []。在marathon_select_opt组件中也需要做一些逻辑处理，主要是对curStageVal这个值
            isFilterable: config.isFilterable ? config.isFilterable : false,
            list,
          })
        }
      })

      this.selectOptData.selectOpt_list = selectOpt_list
      console.debug('this.selectOptData.selectOpt_list', selectOpt_list)
    },
    async changeSelect(data) {
      console.debug('changeSelect:', data)
      let valPathArr = []
      let val = data.val
      if (data.type === 'select') {
        if (val.indexOf('_') > -1) {
          valPathArr = val.split('_')
          for (let i = 0; i < this.selectOptData.selectOpt_list.length; i++) {
            let item = this.selectOptData.selectOpt_list[i]
            const idKey = item.keyVal[0]
            const valKey = item.keyVal[1]
            if (item.type == valPathArr[0]) {
              for (let j = 0; j < item.list.length; j++) {
                let cell = item.list[j]
                console.debug(idKey, val)
                if (cell[idKey] == val) {
                  console.debug(cell[idKey], val)
                  item.curVal = cell[valKey]
                  break
                }
              }
            }
          }
          if (valPathArr[0] === 'event') {
            this.currStageEvent = valPathArr[1]
            this.makeAnalysisItemParams(this.themeTemplateType)
            this.getKnockoutData()
          } else {
          }
        } else {
          console.debug('id命名方式不符合组件规则')
        }
      } else {
        console.debug('data.type 没有匹配成功')
      }
    },
    async getStageEvent() {
      await https_season_eventList(this.axiosBaseUrl, this.$axios, {
        sid: this.currSid,
      })
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            this.eventArr = res.data && res.data.length > 0 ? res.data : []
            if (this.eventArr && this.eventArr.length > 0) {
              this.computedSelectOpt(this.selectOptData.configArr)
              this.currStageEvent = this.eventArr[0].eventId
              this.makeAnalysisItemParams(this.themeTemplateType)
              this.getKnockoutData()
            }
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
    async getKnockoutData() {
      if (this.isNotDataFlag) {
        this.isNotDataFlag = false
      }
      await https_badminton_knockoutData(this.axiosBaseUrl, this.$axios, {
        sid: this.currSid,
        eventId: this.currStageEvent,
      })
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            if (!res.data || (res.data && res.data.length == 0)) {
              this.isNotDataFlag = true
            }
            this.origin_knockoutList = res.data
              ? { data: { dataList: res.data } }
              : { data: { dataList: [] } }
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
  },
}
</script>

<style lang="scss" scoped>
#badmintom_knockoutRounds {
  .publishBtn_row {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
    width: 100%;
    height: 4.16vw;
    display: flex;
    display: -webkit-flex;
    justify-content: flex-end;
    align-items: center;
    width: 100%;
    /* .theme_publishBtn {
        width: 4.16vw;
        text-align: center;
        svg.publishBtn_icon {
          fill: var(--mixtmt_greyColor4);
        }
      } */
    .shareBtnArea {
      margin-left: 1.388vw;
      width: 9.74vw;
      height: 3.2vw;
      display: flex;
      display: -webkit-flex;
      justify-content: center;
      align-items: center;
      background-color: var(--mixtmt_subColor1_1);
      border: 1px solid var(--mixtmt_subColor1_1);
      border-radius: 0.347vw;
      color: var(--mixtmt_whiteColor);
      transition: all 0.3s linear;
      .shareBtn {
        font-size: 1.11vw;
      }
      .publishBtn {
        width: 1.8vw;
        text-align: center;
        svg.publishBtn_icon {
          fill: var(--mixtmt_whiteColor);
        }
      }
    }
    .shareBtnArea {
      &:hover {
        cursor: pointer;
        background-color: var(--mixtmt_mainColor);
        border: 1px solid var(--mixtmt_mainColor);
        color: var(--mixtmt_whiteColor);
      }
    }
  }
  .select_area {
    position: relative;
    padding-top: 2.778vw;
    width: 100%;
    height: 9.028vw;
  }

  .match_list {
    padding-top: 4.16vw;
    position: relative;
  }
}
.mixtmt_pc #badmintom_knockoutRounds,
.mixtmt_ipad #badmintom_knockoutRounds {
  .theme_publishBtn {
    cursor: pointer;
    &:hover {
      svg.publishBtn_icon {
        fill: var(--mixtmt_subColor1_1);
      }
    }
  }
}
</style>
